import {
    Component,
    EventEmitter,
    Input,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { TranslatePipe } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { OrderService } from "~app/features/forsaljning/order/order.service";
import { DisabledControlDirective } from "../../../../../../common/directives/disabled-control/disabled-control.directive";
import { IAlternativMottagningsplats, ILagerplats, IMottagningsplats, IMottagningsplatsTypeAheadResult } from "../../../models/kundorder-detail-model";

@Component({
    selector: "rask-alternativa-mottagningsplatser",
    templateUrl: "./alternativa-mottagningsplatser.component.html",
    styleUrls: ["./alternativa-mottagningsplatser.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule,
        DisabledControlDirective,
        ButtonComponent,
        ListComponent,
        ListColumnDirective,
        IconButtonComponent,
        TranslatePipe
    ]
})
export class AlternativaMottagningsplatserComponent {
    @Input() alternativaMottagningsplatser: IAlternativMottagningsplats[];
    @Input() readonly = false;

    @Input() mottagningsplatsDisabled: (item: IMottagningsplatsTypeAheadResult) => boolean;
    @Input() mottagningsplatsViewFormatter: (item: any) => string;
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onChange = new EventEmitter();
    @Input() search: (input: string) => Observable<IMottagningsplatsTypeAheadResult[]>;
    selectedLagerplats: ILagerplats;
    selectedMottagningsplats: IMottagningsplats;
    lagerplatser = [];

    private readonly authenticationService = inject(AuthenticationService);
    private readonly orderService = inject(OrderService);

    lagerplatserViewFormatter = (l) => `${l.kod ?? l.avlamningsplats} ${l.namn}`;
    canEdit = () => this.authenticationService.canEdit() && !this.readonly;

    add() {
        this.alternativaMottagningsplatser.push({
            mottagningsplatsId: this.selectedMottagningsplats.id,
            mottagningsplats: this.selectedMottagningsplats.namn,
            lagerplats: this.selectedLagerplats,
            id: 0
        });
        this.alternativaMottagningsplatser = this.alternativaMottagningsplatser.splice(0); // Re-assign binding
        this.selectedMottagningsplats = null;
        this.selectedLagerplats = null;
        this.onChange.emit(this.alternativaMottagningsplatser);
    }

    canAdd() {
        const isSelected = this.selectedMottagningsplats && this.selectedMottagningsplats.id;
        return isSelected && !this.alternativaMottagningsplatser.some(x => x.mottagningsplatsId === this.selectedMottagningsplats.id &&
            x.lagerplats?.id === this.selectedLagerplats?.id);
    }

    delete(item) {
        const index = this.alternativaMottagningsplatser.indexOf(item);
        this.alternativaMottagningsplatser.splice(index, 1);
        this.alternativaMottagningsplatser = this.alternativaMottagningsplatser.splice(0); // Re-assign binding
        this.onChange.emit(this.alternativaMottagningsplatser);
    }

    mottagningsplatsChange() {
        this.updateLagerplatser();
    }

    updateLagerplatser() {
        this.selectedLagerplats = null;
        if (!this.selectedMottagningsplats) {
            this.lagerplatser = [];
            return;
        }
        this.orderService.getLagerplatser(this.selectedMottagningsplats).subscribe(l => this.lagerplatser = l);
    }
}
